import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';
import draftTypes from 'constants/draftTypes';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';

const AddDraftInvestorModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddDraftInvestorModal();

  const translationSuffix =
    data.draftType === draftTypes.DRAFT_CAPITAL_INCREASE ? '.FORCED' : '';

  const headerLabel =
    data.modalActionType === actionTypes.EDIT
      ? t(`EditInvestor${translationSuffix}`)
      : t(`AddInvestor${translationSuffix}`);

  return (
    <Modal.Header>
      <h5 className="modal-title">{headerLabel}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddDraftInvestorModalHeader;
